import client from "@/common/client"
import type { IConfig } from "@/common/interfaces"

const commonRepository = {
    getVariant: (): Promise<string> => client.get("/api/variant"),
    getConfig: (): Promise<IConfig> => client.get("/api/config")
}

export default commonRepository
